import { configMock } from "../../mocks/config";
import {
  NETWORK_WARNINGS_INACTIVE,
  NETWORK_WARNINGS_ACTIVE,
  handleRawResponse,
  urlAddTenant,
} from ".";
import { setup as analyticsSetup } from "../../integartions/firebaseAnalytics";
import { setup as sentrySetup } from "../../integartions/sentry";
import { API_SET_CONFIGURATION } from "..";
import { delayedPromise } from "../../delayedPromise";

/**
 * GET /{tenant}/config
 */
export const getConfiguration = () => (dispatch) => {
  dispatch({ type: NETWORK_WARNINGS_ACTIVE });
  let promise = null;
  if (process.env.REACT_APP_MOCK_API === "true") {
    promise = delayedPromise(configMock);
  } else {
    const controller = new AbortController();
    const signal = controller.signal;
    setTimeout(() => {
      controller.abort();
    }, process.env.REACT_APP_CLIENT_TIMEOUT || 30000);

    promise = fetch(urlAddTenant("/config"), { signal }).then(
      handleRawResponse
    );
  }

  return promise.then((payload) => {
    if (process.env.NODE_ENV === "production" && payload.extraConfig) {
      if (payload.extraConfig.firebase) {
        analyticsSetup(payload.extraConfig.firebase);
      }
      if (payload.extraConfig.sentry) {
        sentrySetup(payload.extraConfig.sentry);
      }
    }
    dispatch({ type: API_SET_CONFIGURATION, payload });
    dispatch({ type: NETWORK_WARNINGS_INACTIVE });
    return payload;
  });
};
